<template>
  <div class="pa-4">
    <v-alert type="info">
      Her skal oppsettet for kioskløsningen settes opp! Velg et eller flere
      prosjekter denne kiosken hører til
    </v-alert>
    <div class="pa-4 selectedBox">
      <h3 class="mb-3">Valgte prosjekter</h3>
      <div v-if="getProjectsSelected.length > 0">
        <ProjCards v-model="getProjectsSelected" @click="selectProject">
          <template v-slot:btnRightDown>
            <v-btn text>Slett prosjekt </v-btn>
          </template>
        </ProjCards>
      </div>
      <div v-else>Det er ingen prosjekter valg!</div>
      <v-btn
        class="mt-3"
        color="primary"
        :disabled="getProjectsSelected.length === 0"
        @click="saveProsjekts"
      >
        Lagre valgte prosjekter
      </v-btn>
    </div>

    <Searchbar class="mt-4 mb-4" v-model="search" />
    <div class="pa-4">
      <h3>Prosjekter</h3>
      <div>
        <ProjCards v-model="getProjects" @click="selectProject">
          <template v-slot:btnRightDown>
            <v-btn text>Velg prosjekt </v-btn>
          </template>
        </ProjCards>
      </div>
    </div>
    <v-btn
      v-scroll="onScroll"
      v-show="fab"
      fab
      fixed
      bottom
      right
      color="primary"
      @click="toTop"
    >
      <v-icon>mdi-chevron-up</v-icon>
    </v-btn>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import projectApi from "@/api/projectApi";
import { ProjectObject } from "@/types/interface";

import Searchbar from "@/components/shared/search/Searchbar.vue";
import ProjCards from "@/components/projects/children/ProjCards.vue";
import notification from "@/helpers/notification";

export default Vue.extend({
  data() {
    return {
      search: "",
      projects: [] as Array<ProjectObject>,
      fab: false,
    };
  },
  async mounted() {
    await projectApi.getProjectsKiosk().then((response) => {
      this.projects = response.projects;
    });
  },
  methods: {
    saveProsjekts() {
      if (this.getProjectsSelected?.length > 0) {
        localStorage.setItem(
          "kioskProjects",
          JSON.stringify(this.getProjectsSelected)
        );
        this.$router.push({ name: "Dashboard" });
      } else {
        notification.warn("Ingen prosjekter valgt!");
      }
    },
    selectProject(project: ProjectObject) {
      this.$set(project, "selected", !project.selected);
    },
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 100;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
  },
  computed: {
    getProjects(): Array<ProjectObject> {
      return this.projects?.filter((x) => {
        return (
          (this.search
            ? x.name.toUpperCase().includes(this.search.toUpperCase())
            : true) && !x.selected
        );
      });
    },
    getProjectsSelected(): Array<ProjectObject> {
      return this.projects.filter((x) => x.selected);
    },
  },

  components: {
    Searchbar,
    ProjCards,
  },
});
</script>

<style lang="scss" scoped>
.selectedBox {
  background-color: var(--v-collapsableHeaderBG-base);
  min-height: 272px;
  border-radius: 8px;
}
</style>
